module.exports = __webpack_public_path__ + "img/OpcioA_600x600.11bdb83e.gif";